import { cn } from '@/lib/shadcn/utils';
import type { Verdict } from '@/modules/jobs/signal/types';
import { type VerdictTone, verdictTone } from '@/modules/jobs/signal/verdict';

/** Dot colour per tone, using the repo's semantic design tokens (matching the original prototype). */
export const TONE_DOT: Record<VerdictTone, string> = {
  strong: 'bg-semantic-560',
  weak: 'bg-semantic-540',
  'not-ready': 'bg-semantic-540',
};

/** Convenience: dot class straight from a verdict. */
export function verdictDot(verdict: Verdict): string {
  return TONE_DOT[verdictTone(verdict)];
}

/** Chip border/background per verdict — green-ish for strong, amber for weak/soft, dashed grey for unknown. */
export function verdictChipClass(verdict: Verdict): string {
  if (verdict === 'unknown') return 'border-neutral-400 border-dashed';
  return cn(
    verdictTone(verdict) === 'strong'
      ? 'border-semantic-560/40'
      : 'border-semantic-540/50 bg-semantic-540/10',
  );
}
